var countdownElements = document.querySelectorAll(".countdown");
if (countdownElements.length > 0) {

  function calculateCountdown() {
    var currentTime = new Date();
    var targetTime = new Date();
    targetTime.setHours(13, 0, 0, 0); // Ustawienie godziny 13:00

    var timeDifference = targetTime - currentTime;

    if (timeDifference < 0) {
      // Jeśli czas mija, ustaw czas na kolejny dzień
      targetTime.setDate(targetTime.getDate() + 1);
      timeDifference = targetTime - currentTime;
    }

    var hours = Math.floor(timeDifference / (1000 * 60 * 60));
    var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    // Formatowanie licznika w formacie <span>HH</span> : <span>MM</span> : <span>SS</span>
    var formattedHours = '<span>' + ("0" + hours).slice(-2) + '</span>';
    var formattedMinutes = '<span>' + ("0" + minutes).slice(-2) + '</span>';
    var formattedSeconds = '<span>' + ("0" + seconds).slice(-2) + '</span>';

    return formattedHours + " : " + formattedMinutes + " : " + formattedSeconds;
  }

  // Funkcja aktualizująca wartość licznika co sekundę
  function updateCountdown() {
    var countdown = calculateCountdown();

    // Aktualizacja wszystkich elementów o klasie "countdown"
    for (var i = 0; i < countdownElements.length; i++) {
      countdownElements[i].innerHTML = countdown;
    }

    setTimeout(updateCountdown, 1000);
  }

  // Rozpoczęcie aktualizacji licznika po załadowaniu strony
  window.onload = function() {
    updateCountdown();
  };
}